import { trans } from "~/providers/lang";

import "./style.less";

interface IDay {
	id: number;
	name: string;
	date: string;
	value: string;
}

export default function ChristmasOpening() {
	const hourStr = trans("common.hour");
	const items: Array<IDay> = [
		{
			id: 0,
			name: trans("common.days.4"),
			date: "20. 12.",
			value: `11:00 - 17:00 ${hourStr}`,
		},
		{
			id: 1,
			name: trans("common.days.5"),
			date: "21. 12.",
			value: `10:00 - 11:00 ${hourStr}`,
		},
		{
			id: 2,
			name: trans("common.days.6"),
			date: "22. 12.",
			value: trans("common.closed"),
		},
		{
			id: 3,
			name: trans("common.days.0"),
			date: "23. 12.",
			value: `13:00 - 15:00 ${hourStr}`,
		},
		{
			id: 4,
			name: trans("common.days.1"),
			date: "24. 12.",
			value: trans("common.holiday"),
		},
		{
			id: 5,
			name: trans("common.days.2"),
			date: "25. 12.",
			value: trans("common.holiday"),
		},
		{
			id: 6,
			name: trans("common.days.3"),
			date: "26. 12.",
			value: trans("common.holiday"),
		},
		{
			id: 7,
			name: trans("common.days.4"),
			date: "27. 12.",
			value: trans("common.closed"),
		},
		{
			id: 8,
			name: trans("common.days.5"),
			date: "28. 12.",
			value: trans("common.closed"),
		},
		{
			id: 9,
			name: trans("common.days.6"),
			date: "29. 12.",
			value: trans("common.closed"),
		},
		{
			id: 10,
			name: trans("common.days.0"),
			date: "30. 12.",
			value: `13:00 - 16:00 ${hourStr}`,
		},
		{
			id: 11,
			name: trans("common.days.1"),
			date: "31. 12.",
			value: trans("common.closed"),
		},
		{
			id: 12,
			name: trans("common.days.2"),
			date: "1. 1.",
			value: trans("common.holiday"),
		},
	];

	return <div className="christmas-opening">
		<p className="christmas-opening__title">
			{ trans("christmasOpening.title") }
		</p>
		<div className="christmas-opening__days">
			{ items.map(item => <div className="christmas-opening__day" key={item.id}>
				<span className="christmas-opening__dayName">{ item.name }</span>
				<span className="christmas-opening__dayDate">{ item.date }</span>
				<span className="christmas-opening__dayValue">{ item.value }</span>
			</div>)}
		</div>
		<p className="christmas-opening__addLine">
			{ trans("christmasOpening.line1") }
		</p>
		<p className="christmas-opening__addLine">
			{ trans("christmasOpening.line2") }
		</p>
		<p className="christmas-opening__regards">
			{ trans("christmasOpening.regards") }
		</p>
	</div>;
}
